module.exports = __webpack_public_path__ + "img/kidsoft-logo.9860faab.png";